export default "__VITE_ASSET__BzM20tE4__"